import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { get as _get, size as _size } from 'lodash';
import { MapMarkerInfo } from '../../../../../shared/models';

@Component({
  selector: 'app-unassigned-delivery-marker-info',
  templateUrl: './unassigned-delivery-marker-info.component.html',
  styleUrls: ['../marker-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class UnassignedDeliveryMarkerInfoComponent {
  @Input() markerInfo: MapMarkerInfo;

  get stopWindowTime(): string {
    let time = _get(this.markerInfo, 'stopWindowTime');
    if (_size(time) === 0) {
      time = 'N/A';
    }
    return time;
  }

  constructor() {}
}
